import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from './Card';
import { DollarSign, Globe, Palmtree, TrendingUp, Home, PiggyBank } from 'lucide-react';
const benefits = [{
  icon: DollarSign,
  text: 'Salarios internacionales'
}, {
  icon: Globe,
  text: 'Viajar mientras trabajás'
}, {
  icon: Palmtree,
  text: 'Conocer lugares increíbles'
}, {
  icon: TrendingUp,
  text: 'Crecimiento profesional'
}, {
  icon: Home,
  text: 'Menos gastos personales'
}, {
  icon: PiggyBank,
  text: 'Mayor capacidad de ahorro'
}];
export function Benefits() {
  return <section className="py-16 bg-secondary/20" data-id="element-15">
      <div className="px-5" data-id="element-16">
        <motion.div className="text-center mb-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-17">
          <h2 className="text-3xl font-bold text-white font-heading mb-3" data-id="element-18">
            Lo que puede cambiar para vos
          </h2>
          <div className="w-16 h-1 bg-primary mx-auto rounded-full" data-id="element-19"></div>
        </motion.div>

        <div className="grid grid-cols-2 gap-3" data-id="element-20">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} data-id="element-21">
              <Card className="bg-background border-border/50 h-full" data-id="element-22">
                <CardContent className="p-4 text-center flex flex-col items-center gap-2.5" data-id="element-23">
                  <div className="w-11 h-11 rounded-xl bg-primary/10 flex items-center justify-center text-primary" data-id="element-24">
                    <benefit.icon className="w-5 h-5" data-id="element-25" />
                  </div>
                  <h3 className="text-sm font-bold text-white/90 leading-tight" data-id="element-26">
                    {benefit.text}
                  </h3>
                </CardContent>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}